module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_is-object.js
 ** module id = 91
 ** module chunks = 0
 **/